/* eslint-env node, browser */
import React, {Component} from "react";
import PropTypes from "prop-types";

/**
 * Component that alerts if you click outside of it
 */
class OutsideAlerter extends Component {
    constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        const {isActive} = this.props;
        this.attachEvents(isActive);
    }

    componentDidUpdate() {
        const {isActive} = this.props;
        this.attachEvents(isActive);
    }

    componentWillUnmount() {
        this.attachEvents(false);
    }

    attachEvents = (isActive) => {
        if (isActive) {
            if (this.props.isMobile) {
                document.addEventListener("touchend", this.handleClickOutside, false);
            } else {
                document.addEventListener("click", this.handleClickOutside);
            }
        } else {
            if (this.props.isMobile) {
                document.removeEventListener("touchend", this.handleClickOutside, false);
            } else {
                document.removeEventListener("click", this.handleClickOutside);
            }
        }
    };

    clickedScrollbar = (evt) => {
        return (
            document.documentElement.clientWidth <= evt.clientX ||
            document.documentElement.clientHeight <= evt.clientY
        );
    };

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside = (event) => {
        //event.stopPropagation();
        //const {debug} = this.props;
        setTimeout(() => {
            const {overlayCheck} = this.props;
            if (this.clickedScrollbar(event)) {
                return;
            }
            if (
                overlayCheck &&
                !document.getElementsByClassName("menu-overlay-sa")[0].classList.contains("display")
            ) {
                return;
            }
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                this.props.componentHandler();
            }
        }, 50);
    };

    render() {
        // const {debug} = this.props;
        // if(debug)
        // console.log(this.props);
        return <div ref={this.setWrapperRef}>{this.props.children}</div>;
    }
}
OutsideAlerter.propTypes = {
    componentHandler: PropTypes.func,
    children: PropTypes.node.isRequired,
    isMobile: PropTypes.bool,
    overlayCheck: PropTypes.bool,
    debug: PropTypes.bool,
    isActive: PropTypes.bool,
};

OutsideAlerter.defaultProps = {
    overlayCheck: true,
    debug: false,
    isActive: false,
};

export default OutsideAlerter;
